import { useEffect } from 'react';

function nudge(element) {
  if (!element) return;
  element.animate(
    [
      { transform: 'translateX(0)', boxShadow: '0 0 0 0 rgba(239,68,68,0)' },
      { transform: 'translateX(-5px)', boxShadow: '0 0 0 3px rgba(239,68,68,.10)' },
      { transform: 'translateX(5px)', boxShadow: '0 0 0 3px rgba(239,68,68,.14)' },
      { transform: 'translateX(-3px)', boxShadow: '0 0 0 3px rgba(239,68,68,.10)' },
      { transform: 'translateX(3px)', boxShadow: '0 0 0 2px rgba(239,68,68,.06)' },
      { transform: 'translateX(0)', boxShadow: '0 0 0 0 rgba(239,68,68,0)' },
    ],
    { duration: 360, easing: 'ease-out' },
  );
}

function isInstagramHandleInput(input) {
  if (!(input instanceof HTMLInputElement)) return false;
  const id = String(input.id || '').toLowerCase();
  const name = String(input.getAttribute('name') || '').toLowerCase();
  const aria = String(input.getAttribute('aria-label') || '').toLowerCase();
  const placeholder = String(input.getAttribute('placeholder') || '').toLowerCase();
  return id === 'leadhandle'
    || id.includes('instagram')
    || name.includes('instagram')
    || aria.includes('instagram')
    || placeholder.includes('instagram handle')
    || input.closest('.lead-handle-input-shell') !== null;
}

export default function CreateLeadValidationGuard() {
  useEffect(() => {
    const disableNativeValidation = () => {
      document.querySelectorAll('.create-lead-compact form').forEach((form) => {
        form.noValidate = true;
      });
    };

    const normalizeInstagramHandle = (event) => {
      const input = event.target;
      if (!isInstagramHandleInput(input)) return;
      const lower = input.value.toLowerCase();
      if (input.value !== lower) input.value = lower;
    };

    const interceptCreateLeadSubmit = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('.create-lead-compact')) return;

      const handleInput = form.querySelector('#leadHandle');
      const nameInput = form.querySelector('#leadName');
      const duplicateCard = form.querySelector('.lead-duplicate-card');

      if (handleInput && !handleInput.value.trim()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        nudge(handleInput.closest('.lead-handle-input-shell') || handleInput);
        handleInput.focus();
        return;
      }

      if (nameInput && !nameInput.value.trim()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        nudge(nameInput);
        nameInput.focus();
        return;
      }

      if (duplicateCard) {
        event.preventDefault();
        event.stopImmediatePropagation();
        duplicateCard.animate(
          [
            { transform: 'translateX(0)', boxShadow: '0 0 0 0 rgba(245,158,11,0)' },
            { transform: 'translateX(-5px)', boxShadow: '0 0 0 3px rgba(245,158,11,.12)' },
            { transform: 'translateX(5px)', boxShadow: '0 0 0 3px rgba(245,158,11,.16)' },
            { transform: 'translateX(-3px)' },
            { transform: 'translateX(3px)' },
            { transform: 'translateX(0)', boxShadow: '0 0 0 0 rgba(245,158,11,0)' },
          ],
          { duration: 360, easing: 'ease-out' },
        );
      }
    };

    disableNativeValidation();

    const observer = new MutationObserver(disableNativeValidation);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('input', normalizeInstagramHandle, true);
    document.addEventListener('submit', interceptCreateLeadSubmit, true);

    return () => {
      observer.disconnect();
      document.removeEventListener('input', normalizeInstagramHandle, true);
      document.removeEventListener('submit', interceptCreateLeadSubmit, true);
    };
  }, []);

  return null;
}
